import {Component, Inject} from "@angular/core";
import {AgentBrandingUtils, ConsumerConsentService, FelloWebsites, phoneNumberPattern} from "fello-common";
import {AgentLeadType, FelloVisitorVariables, FormConfig} from "fello-model";
import {QuestionCardDirective} from "../../../directives/question-card/question-card.directive";
import {FELLO_JOURNEY_TASK_ID} from "../../../injection-token";
import {OfferJourneyService} from "../../../services/offer-journey/offer-journey.service";
import {JourneySettingsService} from "../../../services/journey-settings.service";
import {map, switchMap, take} from "rxjs/operators";
import {combineLatest} from "rxjs";

@Component({
  selector: "app-que-phone-input",
  templateUrl: "./que-phone-input.component.html",
  styleUrls: ["./que-phone-input.component.scss"]
})
export class QuePhoneInputComponent extends QuestionCardDirective {
  userPhone: string;
  phoneNumberPattern = phoneNumberPattern;
  firstName = "";
  lastName = "";
  AgentLeadType = AgentLeadType;
  settings$ = this.journeySettingsService.settings$;
  consentText$ = combineLatest([this.offerJourneyService.felloOfferJourney, this.settings$]).pipe(
    map(([offerJourney, settings]) => {
      return offerJourney.vars.consentLanguage ?? AgentBrandingUtils.getAgencyConsentText(settings);
    })
  );

  get leadType(): AgentLeadType {
    return this.offerJourney.leadType!;
  }

  get formConfig(): FormConfig {
    return this.offerJourney.formConfig!;
  }

  protected readonly felloWebsites = FelloWebsites;

  constructor(
    public offerJourneyService: OfferJourneyService,
    @Inject(FELLO_JOURNEY_TASK_ID) public taskId: string,
    private journeySettingsService: JourneySettingsService,
    private consentApiService: ConsumerConsentService
  ) {
    super(offerJourneyService, taskId);
    this.userPhone = this.offerJourney.vars.userPhone ?? "";
    if (this.offerJourney.vars?.userFullName) {
      this.firstName = this.offerJourney.vars.userFullName.split(" ").slice(0, -1).join(" ");
      this.lastName = this.offerJourney.vars.userFullName.split(" ").slice(-1).join(" ");
    }
  }

  next(): void {
    this.consentText$
      .pipe(
        take(1),
        switchMap(consentText => {
          this.offerJourneyService.markTaskAsLoading(this.taskId);
          return this.consentApiService.createConsentTracker(consentText);
        }),
        switchMap(({consentTrackerId}) => {
          const vars: FelloVisitorVariables = {
            userPhone: this.userPhone,
            userFullName: this.firstName + " " + this.lastName,
            consentTrackerId: consentTrackerId
          };
          return this.offerJourneyService.pushOfferJourneyTask(this.taskId, vars);
        })
      )
      .subscribe();
  }
}
